"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TilesContainer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const react_router_dom_1 = require("react-router-dom");
const query_string_1 = __importDefault(require("query-string"));
const decorators_1 = require("../../../../common/decorators");
const Tile_1 = __importDefault(require("./Tile"));
const SearchAndLanguage_1 = __importDefault(require("../SearchAndLanguage"));
const TilesWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2vmin;
  height: 16vmin;
  padding: 2vmin 20vmin;
  background-color: ${props => (props.brandName === 'upstalsboom-wyk-auf-foehr' ? '#EBEBEB' : 'rgba(28, 27, 27, 1)')};

  @media (orientation: portrait) {
    height: 20vmin;
  }

  .buttons-container {
    @media (orientation: landscape) {
      display: none;
    }

    position: absolute;
    right: 0;
    margin-right: 2vmin;
    gap: 1.5vmin;

    button {
      padding: 1.4vmin;

      svg {
        width: 3.5vmin;
        height: 3.5vmin;
      }
    }
  }
`;
const TilesContainer = (props) => {
    const { navigations, weatherData, brandInfo, currentLocale } = props;
    const location = (0, react_router_dom_1.useLocation)();
    const queryParams = query_string_1.default.parse(location.search);
    const renderTiles = (0, react_1.useMemo)(() => {
        return navigations.homePage.map(navigation => {
            switch (navigation.type) {
                case 'activities':
                case 'offers':
                case 'directory':
                    return (react_1.default.createElement(Tile_1.default, { key: (0, react_uid_1.uid)(navigation), title: navigation.title, currentLocale: currentLocale, svg: navigation.icon, destination: `${location.pathname}/${navigation.type}`, withIcon: true, onTileClick: () => props.updateStore('isCarouselPaused', true), withBackgroundImage: !!(navigation.payload && navigation.payload.imageUrl), image: navigation.payload ? navigation.payload.imageUrl : '' }));
                case 'weather':
                    if (!queryParams.hideweather && Object.keys(weatherData).length > 0 && weatherData.current) {
                        return (react_1.default.createElement(Tile_1.default, { key: (0, react_uid_1.uid)(navigation), title: weatherData.providerText, currentLocale: currentLocale, symbol: weatherData.current.symbol, destination: `${location.pathname}/weather`, withIcon: true, onTileClick: () => props.updateStore('isCarouselPaused', true) }));
                    }
                    return null;
                default:
                    return null;
            }
        });
    }, [navigations.homePage, location.pathname, weatherData, queryParams.hideweather, props.updateStore, currentLocale]);
    return (react_1.default.createElement(TilesWrapper, { brandName: brandInfo && brandInfo.brand.slug, className: "tiles" },
        renderTiles,
        react_1.default.createElement(SearchAndLanguage_1.default, null)));
};
exports.TilesContainer = TilesContainer;
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    currentLocale: store.getValue('currentLocale'),
    navigations: store.getValue('navigations'),
    weatherData: store.getValue('weather'),
    brandInfo: store.getValue('brandInfo'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(exports.TilesContainer);
